import React, { useEffect } from 'react';
import { animateScroll as scroll } from 'react-scroll/modules';

import { InfoMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';

import Signing from '../../../components/Signing/Signing';
import { CompletionReducer } from '../../../reducers/completion';
import { ContextReducer } from '../../../reducers/context';
import { TrackingStep, trackEvent } from '../../../util/piwik-utils';

interface Props {
    completion: CompletionReducer;
    context: ContextReducer;
}

const LoanCompletionSigning = ({ completion, context }: Props): JSX.Element => {
    useEffect(() => {
        trackEvent(TrackingStep.CompletionSigning);
        scroll.scrollToTop();
    }, []);

    const { text } = context.config.data;
    const { esigningUrl } = completion.ongoing;
    return (
        <div className="signing">
            <h1>{text.completionSigningTitle}</h1>
            <p>{text.completionSigningText}</p>
            <Signing context={context} url={esigningUrl} />
            <InfoMessage
                className="signing__info-box"
                text={text.completionSigningInfoBox}
                icon={IconTypes.LYSPAERE_24}
            />
        </div>
    );
};

export default LoanCompletionSigning;
